export const MERCHANT_BRANDING_DEFAULTS = {
  backgroundColor: '#ffffff',
  buttonColor: '#0074d4',
  linkButtonColor: '#00D66F',
};
